import { render } from "./DraggablePage.vue?vue&type=template&id=4ac6dcfa&scoped=true"
import script from "./DraggablePage.vue?vue&type=script&lang=js"
export * from "./DraggablePage.vue?vue&type=script&lang=js"

import "./DraggablePage.vue?vue&type=style&index=0&id=4ac6dcfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac6dcfa"]])

export default __exports__